import {
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useRef, useState } from "react";
import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
import NocsRequests from "../../stores/NocsRequestsStore";
import General from "../../stores/GeneralStore";
import CloseIcon from "../../assets/CloseIcon.svg";
import { validateDate } from "@mui/x-date-pickers/internals";
import { observer } from "mobx-react";
import User from "../../stores/UserStore";

interface Obj {
  [key: string]: string;
}

interface Props {
  onValidateClick: any;
}

const UserExistModal = ({ onValidateClick }: Props) => {
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      style={{
        width: General?.isLargeScreen ? "40%" : "100%",
        display: "flex",
        flexDirection: "column",

        color: General.contrast.contrastColor
          ? General.contrast.contrastColor
          : General.ColorAss,
        margin: "auto",
        height: "100vh", // Set the height to 100% of the viewport height
        justifyContent: "center", // Center children vertically
        alignItems: "center", // Center children horizontally
        direction:
          General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
            ? "rtl"
            : "ltr",
      }}
    >
      <div
        style={{
          // height: '20%',

          width: "100%",
          justifyContent: "space-between",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : General?.ColorAss,
          display: "flex",
          alignItems: "center",
        }}
        className={General?.colorClass}
      >
        <h1
          style={{
            color: contrast?.contrastColor ? contrast?.contrastColor : "#fff",
            justifySelf: "flex-start",
            fontSize: General?.isLargeScreen ? "" : "2rem",
          }}
        >
          {General?.codeLabels["cm_user_alreday"]?.label
            ? General?.codeLabels["cm_user_alreday"]?.label
            : "User Alredy Exist"}
        </h1>
        <img src={CloseIcon} alt="" onClick={onValidateClick} />
      </div>
      <div
        style={{
          padding: "1rem",
          background: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : "#fff",
          width: "100%",
        }}
      >
        <span
          className={General?.textClass}
          style={{ fontSize: `${General.accessibility.fontSize}rem` }}
        >
          {General?.codeLabels["cm_err_uname_exts"]?.label
            ? General?.codeLabels["cm_err_uname_exts"]?.label
            : "has already contain a user name"}
          &nbsp;
        </span>
        <br />

        {!User?.profile?.personId && (
          <button
            onClick={onValidateClick}
            style={{
              background: "#101e8e",
              color: "#fff",
              height: "3.5rem",
              width: "12.5rem",
              fontSize: `${1.5 * General.accessibility.fontSize}rem`,
              marginTop: "2rem",
            }}
            className={General?.colorClass}
          >
            {General?.codeLabels["cm_login"]?.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default observer(UserExistModal);
